import { Button, Result } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <Result
      extra={
        <Link to="/">
          <Button type="primary">Back Home</Button>
        </Link>
      }
      status="404"
      subTitle="Sorry, the page you visited does not exist."
      title="404"
    />
  );
};
export default NotFound;
